import { render, staticRenderFns } from "./file-system-layout.vue?vue&type=template&id=9ec1b0ba"
import script from "./file-system-layout.vue?vue&type=script&lang=ts"
export * from "./file-system-layout.vue?vue&type=script&lang=ts"
import style0 from "./file-system-layout.vue?vue&type=style&index=0&id=9ec1b0ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports